import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { VsPage } from './vs';
import { PipesModule } from '../../pipes/pipes.module';
// Translation
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
@NgModule({
  declarations: [
    VsPage,
  ],
  imports: [
    IonicPageModule.forChild(VsPage),
    PipesModule,
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: (http: HttpClient) => new TranslateHttpLoader(http),
          deps: [ HttpClient ]
        }
    }),
  ],
})
export class VsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/vs/vs.module.ts